<template>
  <div class="confirm">
    <b-container v-if="loading" class="section section--loader">
      <!--<b-spinner class="mt-4" />-->
      <loader size="large" :show_timing_slot="true" />
    </b-container>
    <div v-else>
      <b-container>
        <!--
                    test 
                    flight_voucher_id: 11
                    confirm_code: BLF7DZSX6
                    ////
                    http://localhost:8666/confirm/20/BLFPJ4MEW
                -->

        <section class="section section--title mb-3">
          <h1 class="h1 ml-0">Ottimo! La tua prenotazione è confermata</h1>

          <p v-if="redirect" class="text-size-lg ml-0 regular">
            (verrai reindirizzato al tuo portale tra
            <b>{{ redirect_counter > 0 ? redirect_counter : 0 }}</b> secondi...)
          </p>

          <!--<p class="text-size-lg ml-0 regular">
                        Ecco i riferimenti della tua prenotazione
                    </p>-->
        </section>

        <section class="section">
          <div class="confirm--panel" compact>
            <h5 class="h4 semibold">Riferimenti della prenotazione</h5>
            <!-- <h5 class="h5 bold">Riferimenti prenotazione {{ brand }}</h5> -->
            <div>
              <div v-if="voucher.carrierReference">
                <p class="text-size-md mb-0">
                  Codice di riferimento della prenotazione
                </p>
                <p class="text-size-lg semibold">
                  {{ voucher.carrierReference }}
                </p>
              </div>

              <p class="text-size-sm mb-0">Beneficiario</p>
              <p class="text-size-lg">
                {{ beneficiary.firstName }} {{ beneficiary.lastName }}
              </p>

              <p class="text-size-sm mb-0">Email di riferimento</p>
              <p class="text-size-lg">
                {{ beneficiary.email }}
              </p>

              <p class="text-size-sm mb-0">Codice di assistenza VadoBay</p>
              <p class="text-size-lg mb-0">
                {{ confirm_code }}
              </p>
              <small>
                (questo non è il codice del tuo volo ma il riferimento della
                prenotazione su
                {{ brand }}: usalo per comunicare con la nostra assistenza in
                caso di bisogno)
              </small>
            </div>
          </div>
        </section>

        <section class="section mt-4">
          <b-alert
            v-if="status == 'ISSUED'"
            variant="success"
            show
            class="d-flex"
          >
            <vb-icon name="email"></vb-icon>
            <div class="ml-2">
              Abbiamo inviato un'email di conferma all'indirizzo
              <span class="semibold">{{ beneficiary.email }}</span
              >. In alcuni casi potrebbero essere necessari anche oltre 10
              minuti dal momento del booking. Se non la trovi controlla anche la
              casella di spam. Se non hai ricevuto l'email di conferma
              contattaci al numero
              <span class="semibold">{{ phone_number }}</span> o all'indirizzo
              <span class="semibold">{{ email_support }}</span
              >.
            </div>
          </b-alert>
          <b-alert
            v-else-if="status == 'PENDING'"
            variant="warning"
            show
            class="d-flex"
          >
            <div>
              La prenotazione è definitivamente confermata solo nel momento in
              cui ricevi l'email di conferma che invieremo all'indirizzo
              <span class="semibold">{{ beneficiary.email }}</span
              >. In alcuni casi potrebbero essere necessari anche oltre 10
              minuti dal momento del booking. Controlla anche la casella di
              spam. Se sei sicuro di non avere ricevuto l'email di conferma
              contattaci al numero
              <span class="semibold">{{ phone_number }}</span> o all'indirizzo
              <span class="semibold">{{ email_support }}</span
              >.
            </div>
          </b-alert>
          <b-alert
            v-else-if="status == 'NOTCONFIRMED'"
            variant="danger"
            show
            class="d-flex"
          >
            <div>
              Ci sono stati alcuni problemi nel confermare la tua prenotazione.
              Ti invitiamo a contattarci appena possibile per ottenere il
              supporto di un nostro consulente
              <span class="semibold">{{ phone_number }}</span> o all'indirizzo
              <span class="semibold">{{ email_support }}</span
              >.
            </div>
          </b-alert>
          <b-alert v-else variant="danger" show class="d-flex">
            <!-- UNKNOWN o altro-->
            <div>
              Lo stato di questa prenotazione richiede una verifica. Contattaci
              al numero
              <span class="semibold">{{ phone_number }}</span> o all'indirizzo
              <span class="semibold">{{ email_support }}</span
              >.
            </div>
          </b-alert>
          <hr />
        </section>
      </b-container>

      <b-container>
        <section class="section section--title">
          <h1 class="h1 ml-0">Qui sotto trovi il riepilogo del tuo volo</h1>
        </section>

        <b-alert
          v-if="status == 'ISSUED'"
          variant="info"
          class="d-flex flex-column mb-4"
          show
        >
          <div class="h6-size semibold d-flex" style="gap: 5px">
            <vb-icon name="ticket" color="#246D78" class="title-icon"></vb-icon>
            <span>Check-in Online</span>
          </div>
          <p class="d-flex flex-column text-content" style="font-size: 12px">
            <span
              >24 ore prima della partenza ricorda di fare il check-in online
              sul sito della compagnia aerea e di scaricare le carte
              d’imbarco.</span
            >
            <span
              >Attenzione! Prendi nota di queste credenziali con cui effettuare
              l’accesso:</span
            >
          </p>
          <p class="d-flex flex-column" style="font-size: 12px">
            <span class="d-flex" style="gap: 5px"
              ><b class="text-content">Numero di prenotazione:</b
              ><b>{{ voucher.carrierReference }}</b></span
            >
            <span class="d-flex" style="gap: 5px"
              ><b class="text-content">Mail:</b
              ><b>{{ voucher.emailPnr }}</b></span
            >
          </p>
          <p class="d-flex flex-column text-content" style="font-size: 12px">
            Fare il chekin online è semplice: entra nella tua area riservata e
            segui le istruzioni della compagnia. Per dubbi o assistenza siamo a
            disposizione.
          </p>
        </b-alert>
        <b-row>
          <b-col sm="12" md="7" lg="8" xl="9">
            <div
              v-for="(flight_offer, index) in flight_offers"
              :key="_uid + index"
            >
              <div class="confirm--panel" compact>
                <flight-pad-details :flight_offer="flight_offer" />
              </div>
              <!--<div class="confirm--panel" compact>
                                <h5 class="h5 semibold">Servizi</h5>
                                <div v-for="(traveler,index) in flight_offer.travelerPricings" v-bind:key="_uid + index">
                                    <p>
                                        Viaggiatore {{ traveler.travelerId }} - <span class="semibold">{{ traveler.price.total }} {{ traveler.price.currency }}</span>
                                    </p>

                                </div>
                            </div>-->
              <!--TODO qui ho i bagagli aggiuntivi divisi per viaggiatore e per segmento, capire come mostrarli-->
              <!--TODO capire come mostrare i bagagli inclusi-->
            </div>
            <div class="confirm--panel" compact>
              <h5 class="h5 semibold">Viaggiatori</h5>
              <b-row>
                <b-col
                  class="mb-2"
                  md="6"
                  v-for="(traveler, index) in travelers"
                  v-bind:key="_uid + index"
                >
                  <p class="text-size-sm mb-0">Nome</p>
                  <p class="text-size-lg mb-1">
                    {{ traveler.name.firstName }}
                    {{ traveler.name.middleName }} {{ traveler.name.lastName }}
                  </p>
                  <!--<p class="text-size-sm mb-0">
                                        Email
                                    </p>
                                    <p class="text-size-lg">
                                        {{ traveler.contact.emailAddress }}
                                    </p>--><!-- l'email non la chiediamo più (e viene forzata sotto al cofano quella dell'agenzia, non mostrarla)-->

                  <!-- alcune lccs tolgono i contacts dagli altri pax -->
                  <div
                    v-if="
                      traveler.contact && (traveler.contact.phones || []).length
                    "
                  >
                    <p class="text-size-sm mb-0">Telefono</p>
                    <p class="text-size-lg mb-1">
                      <span
                        class="d-block"
                        v-for="(phone, index_phone) in traveler.contact.phones"
                        v-bind:key="_uid + index_phone"
                      >
                        +{{ traveler.contact.phones[0].countryCallingCode }}
                        {{ traveler.contact.phones[0].number }}
                      </span>
                    </p>
                  </div>
                  <!-- tickets -->
                  <div class="mb-2" v-if="tickets.length">
                    <div
                      v-for="(ticket, ticket_index) in tickets.filter((t) => {
                        return t.travelerId == traveler.id;
                      })"
                      v-bind:key="`sId${_uid}${ticket_index}`"
                    >
                      <div
                        class="mb-0"
                        v-for="(
                          ticket_segment, ticket_segment_index
                        ) in ticket.segmentIds"
                        v-bind:key="`s${_uid}tsid${ticket_segment_index}`"
                      >
                        <div
                          v-for="(
                            itinerary, itinerary_index
                          ) in first_flight_offer.itineraries"
                          v-bind:key="`i${_uid}i${itinerary_index}`"
                        >
                          <div
                            v-for="(
                              segment, segment_index
                            ) in itinerary.segments"
                            v-bind:key="`i${_uid}s${segment_index}`"
                          >
                            <!-- ckeck per non replicare segmenti in ticket con un solo itinerario-->
                            <div
                              v-if="
                                (first_flight_offer.itineraries.length == 1 &&
                                  segment_index == 0) ||
                                first_flight_offer.itineraries.length > 1
                              "
                            >
                              <div v-if="segment.id == ticket_segment">
                                <!--ticket_segment: {{ ticket_segment }}-->
                                <div
                                  class="mt-1"
                                  v-if="ticket.documentType == 'ETICKET'"
                                >
                                  <div class="d-flex align-center">
                                    <div class="mr-2">
                                      <b-badge variant="cta">{{
                                        ticket.documentType
                                      }}</b-badge>
                                    </div>
                                    <div class="d-flex mr-1">
                                      <div>
                                        {{
                                          itinerary.segments[0].departure
                                            .iataCode
                                        }}
                                      </div>
                                      <div class="mx-1">-</div>
                                      <div class="mr-1">
                                        {{
                                          itinerary.segments[
                                            itinerary.segments.length - 1
                                          ].arrival.iataCode
                                        }}
                                      </div>
                                      <div>
                                        ({{
                                          reverse_date(
                                            itinerary.segments[0].departure.at,
                                          )
                                        }})
                                      </div>
                                    </div>
                                  </div>

                                  <!-- status and services by segment -->
                                  <div
                                    class="pl-2"
                                    :set_traveler_pricing="
                                      traveler_pricing =
                                        first_flight_offer.travelerPricings.filter(
                                          (t) => {
                                            return t.travelerId == traveler.id;
                                          },
                                        )[0]
                                    "
                                  >
                                    <div>
                                      <small class="mr-1"
                                        >Ticket number:
                                        {{ ticket.documentNumber }}</small
                                      >
                                      <b-badge
                                        :variant="
                                          ticket.documentStatus == 'ISSUED'
                                            ? 'success'
                                            : 'warning'
                                        "
                                        >{{ ticket.documentStatus }}</b-badge
                                      >
                                    </div>

                                    <div
                                      :set_fare_details_by_segment="
                                        fare_details_by_segment = (
                                          traveler_pricing.fareDetailsBySegment ||
                                          []
                                        ).filter((f) => {
                                          return f.segmentId == segment.id;
                                        })[0]
                                      "
                                    ></div>
                                    <template v-if="fare_details_by_segment">
                                      <div
                                        v-if="
                                          fare_details_by_segment.includedCheckedBags
                                        "
                                      >
                                        <small
                                          >Included checked bags:
                                          {{
                                            fare_details_by_segment
                                              .includedCheckedBags.quantity
                                          }}</small
                                        >
                                      </div>
                                      <div
                                        v-if="
                                          fare_details_by_segment.mealServices
                                        "
                                      >
                                        <div
                                          v-for="(
                                            meal_service, meal_service_index
                                          ) in fare_details_by_segment.mealServices"
                                          v-bind:key="`ms${meal_service_index}`"
                                        >
                                          <small
                                            >Meal services: "{{
                                              meal_service.label
                                            }}"</small
                                          >
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </div>
                                <div
                                  v-if="ticket.documentType == 'EMD'"
                                  class="mt-1"
                                >
                                  <div class="d-flex align-center">
                                    <div class="mr-2">
                                      <b-badge variant="primary">{{
                                        ticket.documentType
                                      }}</b-badge>
                                    </div>
                                    <div class="d-flex mr-2">
                                      <div>
                                        {{
                                          itinerary.segments[0].departure
                                            .iataCode
                                        }}
                                      </div>
                                      <div class="mx-1">-</div>
                                      <div class="mr-1">
                                        {{
                                          itinerary.segments[
                                            itinerary.segments.length - 1
                                          ].arrival.iataCode
                                        }}
                                      </div>
                                      <div>
                                        ({{
                                          reverse_date(
                                            itinerary.segments[0].departure.at,
                                          )
                                        }})
                                      </div>
                                    </div>
                                  </div>
                                  <div class="pl-2">
                                    <div class="mr-2">
                                      <div>
                                        <small class="mr-1"
                                          >Ticket number:
                                          {{ ticket.documentNumber }}</small
                                        >
                                        <b-badge
                                          :variant="
                                            ticket.documentStatus == 'ISSUED'
                                              ? 'success'
                                              : 'warning'
                                          "
                                          >{{ ticket.documentStatus }}</b-badge
                                        >
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="traveler.documents">
                    <p class="text-size-sm mb-0">Documento</p>
                    <p class="text-size-lg">
                      <span
                        class="d-block"
                        v-for="(document, index_document) in traveler.documents"
                        v-bind:key="_uid + index_document"
                      >
                        Numero: {{ document.number }} - Scadenza:
                        {{ document.expiryDate }}
                      </span>
                    </p>
                  </div>
                </b-col>
              </b-row>
            </div>

            <additional-services-booked
              v-if="first_flight_offer"
              :flight_offer="first_flight_offer"
              :travelers="travelers"
            />

            <div class="confirm--panel" compact>
              <h5 class="h4 semibold d-flex" style="gap: 5px">
                <vb-icon name="ticket" class="title-icon"></vb-icon>
                <span>Check-in Online</span>
              </h5>
              <p v-if="checkin_online_info" v-html="checkin_online_info"></p>
              <p v-else>
                Questo documento e il codice riportato in questa email non ti
                danno diritto all'imbarco. Per effettuare l'imbarco devi
                effettuare il check-in online prima della partenza. Il check-in
                online va obbligatoriamente effettuato sul sito della compagnia
                aerea nei termini e nelle modalità indicate sul sito stesso. Ti
                invitiamo a visitare e consultare il sito della compagnia aerea
                con attenzione
              </p>
            </div>

            <div class="confirm--panel" compact v-if="status == 'ISSUED'">
              <div class="h3 ml-0 mb-1">
                Accedi alla tua prenotazione sul sito della compagnia aerea
              </div>
              <p>
                Accedi sul sito della compagnia utilizzando il codice
                <b>{{ voucher.carrierReference }}</b> ed il nominativo
                <b>{{ voucher.contactNameSurname }}</b>
                <br />
                <small
                  >(nel caso in cui venisse richiesto anche un indirizzo email,
                  utilizza <b>{{ voucher.emailPnr }}</b
                  >)</small
                >
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">I tuoi bagagli</div>
              <p>
                Per avere una descrizione completa delle condizioni di imbarco
                dei tuoi bagagli relativamente a franchigie, peso, dimensioni,
                accedi alla tua prenotazione sul sito della compagnia aerea
                seguendo le istruzioni indicate qui sopra.
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">Gestione della prenotazione</div>
              <p>
                Tutte le possibili opzioni di gestione della tua prenotazione
                sono disponibili facendo accesso al sito della compagnia
                seguendo le istruzioni riportate qui sopra.
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">Acquisito di servizi aggiuntivi</div>
              <p>
                Sul sito della compagnia, se non già inclusi nella tariffa che
                hai prenotato, potrai aggiungere alla tua prenotazione una ampia
                lista di servizi come posti selezionati, imbarco prioritario,
                bagagli aggiuntivi, bagagli speciali, ecc.
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">Covid</div>
              <p>
                Trovi le informazioni adeguate relativamente alle normative di
                sicurezza Covid sul sito
                <a href="https://www.viaggiaresicuri.it/home" target="_blank"
                  >Viaggiare sicuri</a
                >
                del Ministero degli esteri e sul sito della compagnia aerea.
              </p>
              <hr />
              <div class="h3 ml-0 mb-1">
                Richieste di assistenza ed esigenze speciali
              </div>
              <p>
                Se hai necessità di una assistenza speciale per motivi di
                disabilità o salute ti invitiamo a contattare la compagnia
                aerea. Lo stesso consiglio vale per esigenze alimentari
                speciali.
              </p>
            </div>
          </b-col>
          <b-col m="12" md="5" lg="4" xl="3">
            <div class="confirm--panel pt-0" compact>
              <div class="mt-4 pt-3 d-flex justify-content-between">
                <h3 class="h3 mb-0">Totale</h3>
                <h3 class="h3 mb-0">{{ voucher.live_price }} EUR</h3>
              </div>
              <div>
                <p class="mb-2" style="margin-top: 10px">
                  Tariffa, tasse e spese amministrative per tutti i partecipanti
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { get_confirmation } from "@liveflight/providers";
import {
  reverse_date,
  get_config,
  get_object_field,
  log,
} from "@/utilities/commons";
import FlightPadDetails from "@liveflight/components/blocks/flight-pad/flight-pad-details/flight-pad-details";
import AdditionalServicesBooked from "@liveflight/components/blocks/additional-services-booked.vue";

export default {
  name: "confirm",
  components: {
    "additional-services-booked": AdditionalServicesBooked,
    "flight-pad-details": FlightPadDetails,
  },
  props: {
    confirm_code: String,
    flight_voucher_id: String,
    ignore_redirect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      voucher: {},
      beneficiary: {},
      // Canonical normalized FlightOffers lifted to voucher root by the
      // provider; first_flight_offer is the [0] convenience for code
      // paths that reach into itineraries outside the per-offer v-for.
      flight_offers: [],
      first_flight_offer: {},
      travelers: [],
      tickets: [],
      // Populated in mounted() via get_config so a runtime-loaded
      // $config isn't captured empty by data()'s eager evaluation.
      brand: "",
      phone_number: "",
      email_support: "",
      status: "",
      post_sell_notice: {},
      redirect: false,
      redirect_counter: 30,
      redirect_interval: null,
      checkin_online_info: "",
    };
  },
  beforeDestroy() {
    if (this.redirect_interval) {
      clearInterval(this.redirect_interval);
      this.redirect_interval = null;
    }
  },
  created() {
    this.reverse_date = reverse_date;
  },
  mounted() {
    this.brand = get_config("site.brand", "");
    this.phone_number = get_config("site.phoneNumber", "");
    this.email_support = get_config("site.emailSupport", "");
    let _this = this;
    const orderConfirmedRedirectTo = get_config(
      "integration.orderConfirmedRedirectTo",
      false,
    );
    if (!this.ignore_redirect && orderConfirmedRedirectTo) {
      _this.redirect = true;
      // Decrement first so the visible counter never undershoots; clear
      // before navigating so no orphan tick fires after unmount.
      this.redirect_interval = setInterval(function () {
        _this.redirect_counter = _this.redirect_counter - 1;
        if (_this.redirect_counter <= 0) {
          clearInterval(_this.redirect_interval);
          _this.redirect_interval = null;
          window.location.href = orderConfirmedRedirectTo;
        }
      }, 1000);
    }
    get_confirmation(this.$store.state.liveflight.flight_offer, {
      flightVoucherId: this.flight_voucher_id,
      confirmcode: this.confirm_code,
    })
      .then(
        (response) => {
          this.flight_offers = get_object_field(
            response,
            "voucher.flight_offers",
            [],
          );
          this.first_flight_offer = this.flight_offers[0] || {};
          this.travelers = get_object_field(response, "voucher.travelers", []);
          this.tickets = get_object_field(response, "voucher.tickets", []);
          this.voucher = response.voucher;
          this.checkin_online_info = response.checkinOnlineInfo || "";
          this.beneficiary = response.beneficiary;
          this.status = response.status;

          if (response.postSellNotice)
            this.post_sell_notice = response.postSellNotice;
        },
        (error) => {
          this.on_error(error);
        },
      )
      .catch((error) => {
        this.on_error(error);
      })
      .finally(() => {
        this.scroll_top();
        this.loading = false;
      });
  },
  methods: {
    on_error(error) {
      log("confirm.get_confirmation", error);
      this.confirm = {};
      if (this.redirect_interval) {
        clearInterval(this.redirect_interval);
      }
    },
  },
};
</script>

<style lang="scss">
.confirm {
  .title-icon {
    margin-top: -2px;
  }
  &--panel {
    @extend .content-panel !optional;
    margin-bottom: 1rem !important;
  }
  .text-size-sm {
    font-size: $font-size-sm;
  }
  .text-size-lg {
    font-size: $font-size-lg;
  }
}
</style>
